import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import PageTitle from './pageTitle/reducers';

export default combineReducers({
    Auth,
    PageTitle,
});
